<!-- 页面内容 -->

<template>
  <!-- container -->
  <div class='content'>
    <div class="container cont">
      <div class="contV">
        <div class="divB">
          <div class="formV">
            <div class="formVV">
              <div class="name">Add a shipping address</div>
              <div class="valueB">
                <div class="valueB1" :class="numI == 1 ? 'valueA1' : ''">
                  <div class="oneDiv">
                    <span class="one1">contact name</span>
                    <img class="one2" src="@/assets/images2/5.png" alt="" />
                  </div>
                  <el-input v-model="name" @blur="handleBlur" placeholder="" @focus="focusA(1)">
                  </el-input>
                </div>
                <div class="valueB1" :class="numI == 2 ? 'valueA1' : ''">
                  <div class="oneDiv">
                    <span class="one1">Phone Number</span>
                    <img class="one2" src="@/assets/images2/5.png" alt="" />
                  </div>
                  <el-input v-model="Phone" @blur="handleBlur" placeholder="" @focus="focusA(2)">
                  </el-input>
                </div>
              </div>

              <!-- <div class="valueA" :class="numI == 3 ? 'valueA1' : ''" style="margin-top: 16px !important;">
                  <div class="oneDiv">
                      <span class="one1">Shipping Address</span>
                      <img class="one2" src="@/assets/images2/5.png" alt="" />
                  </div>
                  <el-input @blur="handleBlur" v-model="ShippingAddress" placeholder="" @focus="focusA(3)">
                  </el-input>
              </div> -->

              <div class="valueA" :class="numI == 4 ? 'valueA1' : ''" style="margin-top: 16px !important;">
                <div class="oneDiv">
                  <span class="one1">Detailed Address</span>
                  <img class="one2" src="@/assets/images2/5.png" alt="" />
                </div>
                <el-input @blur="handleBlur" v-model="DetailedAddress" placeholder="" @focus="focusA(4)">
                </el-input>
              </div>
              <div class="btn" @click="goAdd">Save</div>
            </div>
          </div>
        </div>

        <!-- deliverList -->
        <div class="DeLiver">
          <div class="DeLiverV">
            <div class="name">Deliver to this address</div>
            <div class="addressList" v-for="(item, index) in deliverList" :key="index" @click="goHrefAddress(item)">
              <div class="addressListV">
                <div class="t1">{{ item.detail }}
                </div>
                <div class="btn">
                  <div class="btn1">
                    <img class="btn11" src="@/assets/images2/27.png" alt="" />
                    <span class="btn12">{{ item.name }}</span>
                    <img class="btn13" src="@/assets/images2/28.png" alt="" />
                    <span class="btn14">{{ item.phonenumber }}</span>
                  </div>
                  <div class="btn2">
                    <img @click="goRet(item)" class="btn21" src="@/assets/images2/25.png" alt="" />
                    <img @click="goRemove(item.deliverId)" class="btn22" src="@/assets/images2/26.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div class="btnv">Set as Shipping Address</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Notification,
  MessageBox,
  Message
} from 'element-ui'

export default {
  data() {
    return {
      ids: '',  //修改要用的id
      numI: -1,//给输入框焦点选中样式
      checked: false,
      email: '',
      Password: '',
      name: '',
      Phone: '',
      house: '',
      address: '',
      PasswordConfirm: '',
      ShippingAddress: '',
      DetailedAddress: '',
      deliverList: [],
    }
  },
  mounted() {
    this.listdeliverApi();
  },
  methods: {
    goHrefAddress(item) {
      if (this.$route.query.type == 2) {
        localStorage.setItem("address", JSON.stringify(item));
        this.$router.push({
          path: "orderConfirm"
        })
      }
      console.warn(item, "item")
    },
    // 新增或者修改
    async goAdd() {
      if (this.name == "" || this.Phone == "" || this.DetailedAddress == "") {
        this.$message({
          message: 'Please enter',
          type: 'warning'
        });
        return
      }
      if (this.ids == "") {
        try {
          const res = await this.$post('system/deliver', {
            detail: this.DetailedAddress,
            name: this.name,
            phonenumber: this.Phone
          });
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.ids = '';
          this.DetailedAddress = '';
          this.name = '';
          this.Phone = '';
          this.listdeliverApi();
        } catch (error) {
        }
      } else {
        try {
          const res = await this.$PUT('system/deliver', {
            detail: this.DetailedAddress,
            name: this.name,
            phonenumber: this.Phone,
            deliverId: this.ids
          });
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.ids = '';
          this.DetailedAddress = '';
          this.name = '';
          this.Phone = '';
          this.listdeliverApi();
        } catch (error) {
        }
      }
    },
    // 收货地址列表
    async listdeliverApi() {
      try {
        const userInfo = this.$store.state.userInfo;
        const res = await this.$get('system/deliver/list?userId=' + userInfo.userId || "", {
          userId: localStorage.getItem("TIANYUE_USER_INFO").userId,
        });
        this.deliverList = res.rows || [];
        console.warn(res.rows, "收货地址列表")
        // 有id为编辑
        const id = this.$route.query.id;
        const info = this.deliverList.find(item => item.deliverId == id);
        if (id && info) this.goRet(info);
      } catch (error) {
      }
    },
    goRet(item) {
      this.ids = item.deliverId;
      this.DetailedAddress = item.detail;
      this.name = item.name;
      this.Phone = item.phonenumber;
      console.warn(item, "item")
    },
    goRemove(id) {
      MessageBox.confirm(
        'Delete or not',
        'hint', {
        confirmButtonText: 'confirm',
        cancelButtonText: 'cancel',
        type: 'warning',
      }
      ).then(async () => {
        try {
          const res = await this.$DEL('system/deliver/' + id);
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.listdeliverApi();
        } catch (error) {
        }
      })
    },
    handleBlur(e) {
      this.numI = -1;
    },
    focusA(e) {
      this.numI = e;
    },
  },
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
